import { ONE_HOUR } from '@belezanaweb/utils/constants';
export var DEFAULT_TIME_TO_EXPIRES = ONE_HOUR / 2;
export var setCookie = function setCookie(cookie) {
  return document.cookie = cookie;
};
export var createCookie = function createCookie(_ref) {
  var name = _ref.name,
      value = _ref.value,
      time = _ref.time,
      _ref$prefix = _ref.prefix,
      prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
      domain = _ref.domain;
  var cookieName = name.includes(prefix) ? name : "".concat(prefix, "-").concat(name);
  var cookie = formatToCookiePattern({
    name: cookieName,
    value: value,
    time: time,
    domain: domain
  });
  setCookie(cookie);
};
export var formatToCookiePattern = function formatToCookiePattern(_ref2) {
  var name = _ref2.name,
      value = _ref2.value,
      time = _ref2.time,
      domain = _ref2.domain;
  var now = new Date();
  var timeToExpires = time || DEFAULT_TIME_TO_EXPIRES;
  var secure = document.location.port ? '' : 'secure';
  now.setTime(now.getTime() + timeToExpires);
  return "".concat(name, "=").concat(value, "; expires=").concat(now.toGMTString(), "; domain=").concat(domain || document.domain.replace(/^(www|loja|checkout)\./, ''), "; path=/; ").concat(secure);
};
export var getCookieByName = function getCookieByName(cookieName) {
  var pattern = new RegExp("".concat(cookieName, "=([^;]+)"));
  var match = document.cookie.match(pattern);
  return match ? match[1] : '';
};